export const RFID_ENDORSEMENTS_REQUEST = "RFID_ENDORSEMENTS_REQUEST";
export const RFID_ENDORSEMENTS_SUCCESS = "RFID_ENDORSEMENTS_SUCCESS";
export const RFID_ENDORSEMENTS_FAIL = "RFID_ENDORSEMENTS_FAIL";
export const RFID_ENDORSEMENT_APPROVE_REQUEST = "RFID_ENDORSEMENT_APPROVE_REQUEST";
export const RFID_ENDORSEMENT_APPROVE_SUCCESS = "RFID_ENDORSEMENT_APPROVE_SUCCESS";
export const RFID_ENDORSEMENT_APPROVE_FAIL = "RFID_ENDORSEMENT_APPROVE_FAIL";